<template>
  <div>
    <loading v-if="loadingRender"></loading>
    <panel Title="فرم پرداخت گروهی" Des="از طریق این فرم می توانید به صورت گروهی اقساط و سپرده های خود را به یکجا پرداخت کنید" :IsBtnBack="true" :IsBtnClose="false" ClassCustom="bg-dark-Custom text-right"></panel>
    <net-pa-card :IsMinus="true" :IdElement="'MyLoan'">
      <template slot="header">
        <h6 class="text-right"><i class="fas fa-gift"></i> تسهیلات خودم</h6>
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-12 text-left">
            <vue-bootstrap4-table v-if="$store.state.renderComponentGrid" :rows="LoanList" :columns="columnsLoan" :config="config" :classes="classes">
              <template slot="sort-asc-icon">
                <i class="fa fa-sort-up"></i>
              </template>
              <template slot="sort-desc-icon">
                <i class="fa fa-sort-down"></i>
              </template>
              <template slot="no-sort-icon">
                <i class="fa fa-sort"></i>
              </template>
              <template slot="empty-results">
                <p class="text-right">اطلاعاتی یافت نشد</p>
              </template>
              <template slot="row" slot-scope="props">
                <p class="text-center">{{ props.row.vbt_id }}</p>
              </template>
              <template slot="mande" slot-scope="props">
                <p class="text-center">{{ $Comma3ragham(props.row.mande - props.row.sumMabTaeedNaShode) }}</p>
              </template>
              <template slot="mablaghVam" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.mablaghVam) }}
                </p>
              </template>
              <template slot="sumMabMoavaghe" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.sumMabMoavaghe) }}
                </p>
              </template>
              <template slot="mablaghGhestVam" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.mablaghGhestVam) }}
                </p>
              </template>
              <template slot="wwwJarime" slot-scope="props">
                <p class="text-center">{{ $Comma3ragham(props.row.wwwJarime == null ? 0 : props.row.wwwJarime) }}</p>
              </template>
              <template slot="SumGhabelPar" slot-scope="props">
                <input
                  class="text-center 3ragham Transparent text-danger"
                  type="text"
                  @keypress="$ValidNumber($event, 13, false)"
                  @keyup="
                    $PutCommatoInput()
                    SumGhabelParLoan(LoanList)
                  "
                  title="برای وارد کردن مبلغ کلیک کنید"
                  v-model="LoanList[props.row.vbt_id - 1].SumGhabelPar"
                />
              </template>
              <template slot="Action" slot-scope="props">
                <small class="">
                  <button type="button" title="برنامه اقساط" class="btn btn-outline-orange ml-2" @click="GetTaahodatRiz(props.row, false)" style="font-size: 14px !important" data-toggle="modal" data-target="#Modal-Success" dir="ltr">
                    <span class="fa fa-list" tabindex="-1"></span>
                  </button>

                  <span class="btn Pointer btn-outline-success" @click="AddToCart(LoanList[props.row.vbt_id - 1], false)"> <i class="fas fa-shopping-bag ml-2"></i> افزودن به لیست پرداخت </span>
                </small>
              </template>
            </vue-bootstrap4-table>
            <div class="btn Pointer btn-danger rounded ml-5 mt-2" @click="AllAddToCart(LoanList)"><i class="fas fa-plus ml-2"></i> افزودن همه تسهیلات به لیست پرداخت</div>
            <span class="float-right mr-2" style="font-size: 16px"
              >جمع مبلغ قابل پرداخت : <span class="text-danger" style="font-size: 16px">{{ $Comma3ragham(SumAllGhabelParLoan) }}</span></span
            >
          </div>
        </div>
      </template>
    </net-pa-card>

    <net-pa-card :Classes="'bg-dark-Custom'" :IsMinus="true" :IdElement="'ChildsLoan'">
      <template slot="header">
        <h6 class="text-right"><i class="fas fa-gift"></i> تسهیلات وابسته</h6>
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-12 text-left">
            <vue-bootstrap4-table v-if="$store.state.renderComponentGrid" :rows="ChildsLoanList" :columns="ChildscolumnsLoan" :config="config" :classes="classes">
              <template slot="sort-asc-icon">
                <i class="fa fa-sort-up"></i>
              </template>
              <template slot="sort-desc-icon">
                <i class="fa fa-sort-down"></i>
              </template>
              <template slot="no-sort-icon">
                <i class="fa fa-sort"></i>
              </template>
              <template slot="empty-results">
                <p class="text-right">اطلاعاتی یافت نشد</p>
              </template>
              <template slot="row" slot-scope="props">
                <p class="text-center">{{ props.row.vbt_id }}</p>
              </template>
              <template slot="mande" slot-scope="props">
                <p class="text-center">{{ $Comma3ragham(props.row.mande - props.row.sumMabTaeedNaShode) }}</p>
              </template>
              <template slot="mablaghVam" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.mablaghVam) }}
                </p>
              </template>
              <template slot="sumMabMoavaghe" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.sumMabMoavaghe) }}
                </p>
              </template>
              <template slot="mablaghGhestVam" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.mablaghGhestVam) }}
                </p>
              </template>
              <template slot="SumGhabelPar" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.SumGhabelPar) }}
                </p>
              </template>
              <template slot="wwwJarime" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.wwwJarime == null ? 0 : props.row.wwwJarime) }}
                </p>
              </template>
              <template slot="SumGhabelPar" slot-scope="props">
                <input
                  class="text-center 3ragham Transparent text-danger"
                  type="text"
                  @keypress="$ValidNumber($event, 13, false)"
                  @keyup="
                    $PutCommatoInput()
                    SumGhabelParChildLoan(ChildsLoanList)
                  "
                  title="برای وارد کردن مبلغ کلیک کنید"
                  v-model="ChildsLoanList[props.row.vbt_id - 1].SumGhabelPar"
                />
              </template>
              <template slot="Action" slot-scope="props">
                <small class="">
                  <button type="button" title="برنامه اقساط" class="btn btn-outline-orange ml-2" @click="GetTaahodatRiz(props.row, true)" style="font-size: 14px !important" data-toggle="modal" data-target="#Modal-Success" dir="ltr">
                    <span class="fa fa-list" tabindex="-1"></span>
                  </button>

                  <div class="btn Pointer btn-outline-success" @click="AddToCart(ChildsLoanList[props.row.vbt_id - 1], false)"><i class="fas fa-shopping-bag ml-2"></i> افزودن به لیست پرداخت</div>
                </small>
              </template>
            </vue-bootstrap4-table>
            <div class="btn Pointer btn-danger rounded ml-5 mt-2" @click="AllAddToCart(ChildsLoanList)"><i class="fas fa-plus ml-2"></i> افزودن همه تسهیلات به لیست پرداخت</div>
            <span class="float-right mr-2" style="font-size: 16px"
              >جمع مبلغ قابل پرداخت : <span class="text-danger" style="font-size: 16px">{{ $Comma3ragham(SumAllGhabelParChildLoan) }}</span></span
            >
          </div>
        </div>
      </template>
    </net-pa-card>

    <net-pa-card :IsMinus="true" :IdElement="'MyAccounts'" :IsCollapse="true">
      <template slot="header">
        <h6 class="text-right"><i class="fas fa-list"></i> حساب ها خودم</h6>
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-12">
            <vue-bootstrap4-table :rows="AccountList" :columns="columnsAccount" :config="config" :classes="classes">
              <template slot="sort-asc-icon">
                <i class="fa fa-sort-up"></i>
              </template>
              <template slot="sort-desc-icon">
                <i class="fa fa-sort-down"></i>
              </template>
              <template slot="no-sort-icon">
                <i class="fa fa-sort"></i>
              </template>
              <template slot="empty-results">
                <p class="text-right">اطلاعاتی یافت نشد</p>
              </template>
              <template slot="row" slot-scope="props">
                <p class="text-center">{{ props.row.vbt_id }}</p>
              </template>
              <template slot="mablaghSharj" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.mablaghSharj) }}
                </p>
              </template>
              <template slot="mande" slot-scope="props">
                <p class="text-center">{{ $Comma3ragham(props.row.mande) }}</p>
              </template>
              <template slot="ghabelBardasht" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.ghabelBardasht) }}
                </p>
              </template>
              <template slot="MabVarizi" slot-scope="props">
                <input class="text-center 3ragham Transparent" type="text" @keypress="$ValidNumber($event, 13, false)" @keyup="$PutCommatoInput()" title="برای وارد کردن مبلغ کلیک کنید" v-model="AccountList[props.row.vbt_id - 1].MabVarizi" />
              </template>
              <template slot="Action" slot-scope="props">
                <small class="">
                  <div class="btn Pointer btn-outline-success" @click="AddToCart(AccountList[props.row.vbt_id - 1], true)"><i class="fas fa-shopping-bag ml-2"></i> افزودن به لیست پرداخت</div>
                </small>
              </template>
            </vue-bootstrap4-table>
          </div>
        </div>
      </template>
    </net-pa-card>

    <net-pa-card :Classes="'bg-dark-Custom'" :IsMinus="true" :IdElement="'ChildsAccount'" :IsCollapse="true">
      <template slot="header">
        <h6 class="text-right"><i class="fas fa-list"></i> حساب ها وابسته</h6>
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-12">
            <vue-bootstrap4-table :rows="ChildsAccountList" :columns="ChildscolumnsAccount" :config="config" :classes="classes">
              <template slot="sort-asc-icon">
                <i class="fa fa-sort-up"></i>
              </template>
              <template slot="sort-desc-icon">
                <i class="fa fa-sort-down"></i>
              </template>
              <template slot="no-sort-icon">
                <i class="fa fa-sort"></i>
              </template>
              <template slot="empty-results">
                <p class="text-right">اطلاعاتی یافت نشد</p>
              </template>
              <template slot="row" slot-scope="props">
                <p class="text-center">{{ props.row.vbt_id }}</p>
              </template>
              <template slot="mablaghSharj" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.mablaghSharj) }}
                </p>
              </template>
              <template slot="mande" slot-scope="props">
                <p class="text-center">{{ $Comma3ragham(props.row.mande) }}</p>
              </template>
              <template slot="ghabelBardasht" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.ghabelBardasht) }}
                </p>
              </template>
              <template slot="MabVarizi" slot-scope="props">
                <input class="text-center 3ragham Transparent" type="text" @keypress="$ValidNumber($event, 13, false)" @keyup="$PutCommatoInput()" title="برای وارد کردن مبلغ کلیک کنید" v-model="ChildsAccountList[props.row.vbt_id - 1].MabVarizi" />
              </template>
              <template slot="Action" slot-scope="props">
                <small class="">
                  <div class="btn Pointer btn-outline-success" @click="AddToCart(ChildsAccountList[props.row.vbt_id - 1], true)"><i class="fas fa-shopping-bag ml-2"></i> افزودن به لیست پرداخت</div>
                </small>
              </template>
            </vue-bootstrap4-table>
          </div>
        </div>
      </template>
    </net-pa-card>

    <modal-custom>
      <template v-slot:ContentModalSuccess>
        <taahodat-riz v-if="$store.state.renderComponent" @SumMablagh="SumMablagh" @SumMablaghJarime="SumMablaghJarime" @ListTaahodatRiz="ListTaahodatRiz" :taahodatId="TaahodatIdForGetRiz"></taahodat-riz>
      </template>
    </modal-custom>
  </div>
</template>
<script>
import VueBootstrap4Table from 'vue-bootstrap4-table'
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import Panel from '../Tools/NetPa/Panel.vue'
import ModalCustom from '../Tools/ModalCustom.vue'
import TaahodatRiz from './TaahodatRiz.vue'
import loading from '../Tools/NetPa/Loading.vue'
import { json } from 'body-parser'
export default {
  components: {
    Panel,
    NetPaCard,
    VueBootstrap4Table,
    ModalCustom,
    TaahodatRiz,
    loading,
  },
  data() {
    return {
      loadingRender: false,
      DataAxiosRow: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat/TaahodatSahebHesab',
        Token: this.$session.get('TokenNetPa'),
      },

      AccountList: [],
      ChildsAccountList: [],

      LoanList: [],
      ChildsLoanList: [],

      columnsAccount: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'ردیف',
          name: 'row',
        },
        {
          label: 'نوع حساب',
          name: 'desNoe',
        },
        {
          label: 'شماره حساب',
          name: 'vCode',
        },
        {
          label: 'تاریخ افتتاح حساب',
          name: 'tarix',
        },
        {
          label: 'موجودی',
          name: 'mande',
        },
        {
          label: 'قابل برداشت',
          name: 'ghabelBardasht',
        },
        {
          label: 'مبلغ واریزی',
          name: 'MabVarizi',
        },
        {
          label: 'عملیات',
          name: 'Action',
        },
      ],
      ChildscolumnsAccount: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'ردیف',
          name: 'row',
        },
        {
          label: 'مشخصات',
          name: 'nameFamily',
        },
        {
          label: 'نوع حساب',
          name: 'desNoe',
        },
        {
          label: 'شماره حساب',
          name: 'vCode',
        },
        {
          label: 'تاریخ افتتاح حساب',
          name: 'tarix',
        },
        {
          label: 'موجودی',
          name: 'mande',
        },
        {
          label: 'قابل برداشت',
          name: 'ghabelBardasht',
        },
        {
          label: 'مبلغ واریزی',
          name: 'MabVarizi',
        },
        {
          label: 'عملیات',
          name: 'Action',
        },
      ],

      columnsLoan: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'ردیف',
          name: 'row',
        },

        {
          label: 'نوع ',
          name: 'desNoe',
        },
        {
          label: 'شماره ',
          name: 'vCode',
        },
        {
          label: ' شروع اقساط',
          name: 'tarixShoroAghsat',
        },
        {
          label: 'مبلغ تسهیلات',
          name: 'mablaghVam',
        },
        {
          label: 'مبلغ قسط',
          name: 'mablaghGhestVam',
        },
        {
          label: 'مانده',
          name: 'mande',
        },
        {
          label: 'مجموع معوق',
          name: 'sumMabMoavaghe',
        },
        {
          label: 'جریمه',
          name: 'wwwJarime',
        },
        {
          label: 'مبلغ قابل پرداخت',
          name: 'SumGhabelPar',
        },
        {
          label: 'عملیات',
          name: 'Action',
        },
      ],
      ChildscolumnsLoan: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'ردیف',
          name: 'row',
        },
        {
          label: 'مشخصات',
          name: 'nameFamily',
        },
        {
          label: 'نوع ',
          name: 'desNoe',
        },
        {
          label: 'شماره ',
          name: 'vCode',
        },
        {
          label: ' شروع اقساط',
          name: 'tarixShoroAghsat',
        },
        {
          label: 'مبلغ تسهیلات',
          name: 'mablaghVam',
        },
        {
          label: 'مبلغ قسط',
          name: 'mablaghGhestVam',
        },
        {
          label: 'مانده',
          name: 'mande',
        },
        {
          label: 'مجموع معوق',
          name: 'sumMabMoavaghe',
        },
        {
          label: 'جریمه',
          name: 'wwwJarime',
        },
        {
          label: 'مبلغ قابل پرداخت',
          name: 'SumGhabelPar',
        },
        {
          label: 'عملیات',
          name: 'Action',
        },
      ],

      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: false,
        card_title: '',
        card_mode: false,
        global_search: {
          placeholder: ' جستجو',
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: 'table-bordered table-striped table-sm ',
      },

      TaahodatIdForGetRiz: null,
      IsChild: false,
      SumAllGhabelParLoan: 0,
      SumAllGhabelParChildLoan: 0,
    }
  },
  methods: {
    GetTaahodat(IsAccount) {
      const formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      if (IsAccount == true) formData.append('wwwtblSarfaslTypeId', 2)
      else formData.append('wwwtblSarfaslTypeId', 1)

      this.DataAxiosRow.ArryfildValue = formData
      this.$PostFormData(this.DataAxiosRow).then((data) => {
        if (IsAccount) {
          //  this.AccountList=data.filter(x=>x.mande>0)
          this.AccountList = data.filter((x) => x.isPayment == true && x.tblSarfaslTypeId != 6)
          this.EditRowsAccount(this.AccountList)
        } else {
          this.LoanList = data.filter((x) => x.mande + x.wwwJarime - x.sumMabTaeedNaShode > 0)

          this.EditRowsLoan(this.LoanList)
          this.SumGhabelParLoan(this.LoanList)
        }
      })
    },
    GetTaahodatSahebHesab(IsAccount) {
      this.loadingRender = true
      const formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      if (IsAccount == true) formData.append('wwwtblSarfaslTypeId', 2)
      else formData.append('wwwtblSarfaslTypeId', 1)

      this.DataAxios_SahebHesab.ArryfildValue = formData
      this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
        if (IsAccount) {
          //  this.ChildsAccountList=data.filter(x=>x.mande>0)
          this.ChildsAccountList = data.filter((x) => x.isPayment == true && x.tblSarfaslTypeId != 6)
          this.EditRowsAccount(this.ChildsAccountList)
        } else {
          this.ChildsLoanList = data.filter((x) => x.mande + x.wwwJarime - x.sumMabTaeedNaShode > 0)
          this.EditRowsLoan(this.ChildsLoanList)
          this.SumGhabelParChildLoan(this.ChildsLoanList)
        }
        this.loadingRender = false
      })
    },
    AddToCart(row, IsAccount) {
      let sumRiz = 0
      if (row.ListTaahodatRiz) {
        sumRiz = this.SumMabTaahodatRiz(row.ListTaahodatRiz)
        console.log('AA', sumRiz)
      }
      if (IsAccount == true) {
        if (Number(row.MabVarizi.replace(/,/g, '')) > 0) {
          row.SumGhabelPar = Number(row.MabVarizi.replace(/,/g, ''))
          this.$Netpa_AddToCart(row, 'Account', 'حساب ها')
        } else {
          this.$mySweetDefaultTost('', 'مبلغ واریزی خالی می باشد لطفا مبلغ واریزی را تکمیل و سپس دوباره تلاش کنید', 'warning', 3000)
        }
      }
      if (IsAccount == false) {
        console.log(row)
        if (row.SumGhabelPar == '' || row.SumGhabelPar == '0') {
          row.SumGhabelPar = row.sumGhabelPar
        } else {
          if (Number((row.SumGhabelPar + '').replaceAll(/,/g, '')) < Number(row.CheckUpMablagh)) {
            var MablaghJarime = row.wwwJarime
            var MabFormulaJarime = (Number((row.SumGhabelPar + '').replaceAll(/,/g, '')) / (Number(row.CheckUpMablagh) - MablaghJarime)) * MablaghJarime
            row.wwwJarime = Math.floor(MabFormulaJarime)
          }
          row.SumGhabelPar = Number((row.SumGhabelPar + '').replaceAll(/,/g, ''))
        }
        if (Number(row.SumGhabelPar) > Number(row.mande + row.wwwJarime) - Number(row.sumMabTaeedNaShode)) {
          this.$mySweetDefaultTost('', ' مبلغ قابل پرداخت وارد شده برای تسهیلات ' + this.$b_InvertCode(row.vCode, '-') + ' بیشتر از مانده تسهیلات می باشد ', 'warning', 3000)
        } else {
          // this.SumJarimeAndMablaghGhestVam(row);
          if (row.SumGhabelPar != sumRiz && sumRiz > 0) {
            row.ListTaahodatRiz = []
          } else this.$Netpa_AddToCart(row, 'Loan', 'تسهیلات')
        }
      }
    },
    EditRowsAccount(listRow) {
      for (let index = 0; index < listRow.length; index++) {
        listRow[index].MabVarizi = 0
      }
    },
    EditRowsLoan(listRow) {
      for (let index = 0; index < listRow.length; index++) {
        listRow[index].SumGhabelPar = listRow[index].sumGhabelPar
        listRow[index].CheckUpMablagh = listRow[index].sumGhabelPar
      }
    },
    SumJarimeAndMablaghGhestVam(row) {
      row.mablaghGhestVam = Number(row.mablaghGhestVam) + Number(row.wwwJarime == null ? 0 : row.wwwJarime)
    },
    GetTaahodatRiz(row, IsChild) {
      this.TaahodatIdForGetRiz = row.id

      this.IsChild = IsChild

      this.$store.state.renderComponent = false
      this.$nextTick(() => {
        this.$store.state.renderComponent = true
      })
    },
    SumMablagh(val) {
      if (this.IsChild == true) {
        for (let index = 0; index < this.ChildsLoanList.length; index++) {
          if (this.ChildsLoanList[index].id == this.TaahodatIdForGetRiz) {
            this.ChildsLoanList[index].SumGhabelPar = val
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
          }
        }
        this.SumGhabelParChildLoan(this.ChildsLoanList)
      } else {
        for (let index = 0; index < this.LoanList.length; index++) {
          if (this.LoanList[index].id == this.TaahodatIdForGetRiz) {
            this.LoanList[index].SumGhabelPar = Number(val)
            // this.$store.state.renderComponentGrid = false;
            // this.$nextTick(() => {
            //     this.$store.state.renderComponentGrid = true;
            //  });
          }
        }
        this.SumGhabelParLoan(this.LoanList)
      }
    },
    SumMablaghJarime(val) {
      if (this.IsChild == true) {
        for (let index = 0; index < this.ChildsLoanList.length; index++) {
          if (this.ChildsLoanList[index].id == this.TaahodatIdForGetRiz) {
            this.ChildsLoanList[index].wwwJarime = val
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
          }
        }
        this.SumGhabelParChildLoan(this.ChildsLoanList)
      } else {
        for (let index = 0; index < this.LoanList.length; index++) {
          if (this.LoanList[index].id == this.TaahodatIdForGetRiz) {
            this.LoanList[index].wwwJarime = val
          }
        }
        this.SumGhabelParLoan(this.LoanList)
      }
    },
    ListTaahodatRiz(listRiz) {
      let sumRiz = this.SumMabTaahodatRiz(listRiz)
      if (this.IsChild == true) {
        for (let index = 0; index < this.ChildsLoanList.length; index++) {
          if (this.ChildsLoanList[index].id == this.TaahodatIdForGetRiz) {
            this.ChildsLoanList[index].ListTaahodatRiz = listRiz
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
          }
        }
        this.SumGhabelParChildLoan(this.ChildsLoanList)
      } else {
        for (let index = 0; index < this.LoanList.length; index++) {
          if (this.LoanList[index].id == this.TaahodatIdForGetRiz) {
            this.LoanList[index].ListTaahodatRiz = listRiz
          }
        }
        this.SumGhabelParLoan(this.LoanList)
      }
    },
    AllAddToCart(Arr) {
      var Ok = true
      for (let index = 0; index < Arr.length; index++) {
        if (Number((Arr[index].SumGhabelPar + '').replace(/,/g, '')) > Number(Arr[index].mande) + Arr[index].wwwJarime - Arr[index].sumMabTaeedNaShode) {
          Ok = false
        }
        if (Arr[index].SumGhabelPar == '' || Arr[index].SumGhabelPar == '0') {
          Ok = false
        }
      }
      if (Ok == true) {
        for (let index = 0; index < Arr.length; index++) {
          if (typeof Arr[index].SumGhabelPar == 'string') {
            Arr[index].SumGhabelPar = Number((Arr[index].SumGhabelPar + '').replace(/,/g, ''))
          }
          if (Number(Arr[index].SumGhabelPar) < Number(Arr[index].CheckUpMablagh)) {
            var MablaghJarime = Arr[index].wwwJarime
            var MabFormulaJarime = (Number(Arr[index].SumGhabelPar) / (Number(Arr[index].CheckUpMablagh) - MablaghJarime)) * MablaghJarime
            Arr[index].wwwJarime = Math.floor(MabFormulaJarime)
          }
          this.$Netpa_AddToCart(Arr[index], 'Loan', 'تسهیلات')
        }
      } else {
        for (let index = 0; index < Arr.length; index++) {
          if (Number((Arr[index].SumGhabelPar + '').replace(/,/g, '')) > Number(Arr[index].mande) + Number(Arr[index].wwwJarime) - Arr[index].sumMabTaeedNaShode) {
            this.$mySweetDefaultTost('', ' مبلغ قابل پرداخت وارد شده برای تسهیلات ' + this.$b_InvertCode(Arr[index].vCode, '-') + ' بیشتر از مانده تسهیلات می باشد ', 'warning', 3000)
            return
          } else {
            this.$mySweetDefaultTost('', ' مبالغ قابل پرداختی شما نمی تواند خالی باشد', 'warning', 3000)
          }
        }
      }
    },
    SumGhabelParLoan(listRow) {
      this.SumAllGhabelParLoan = 0
      for (let index = 0; index < listRow.length; index++) {
        this.SumAllGhabelParLoan += Number(listRow[index].SumGhabelPar.toString().replace(/,/g, ''))
      }
      this.$PutCommatoInput()
    },
    SumGhabelParChildLoan(listRow) {
      this.SumAllGhabelParChildLoan = 0
      for (let index = 0; index < listRow.length; index++) {
        this.SumAllGhabelParChildLoan += Number(listRow[index].SumGhabelPar.toString().replace(/,/g, ''))
      }
    },
    reverseString(str) {
      // Step 1. Use the split() method to return a new array
      var splitString = str.split('') // var splitString = "hello".split("");
      // ["h", "e", "l", "l", "o"]

      // Step 2. Use the reverse() method to reverse the new created array
      var reverseArray = splitString.reverse() // var reverseArray = ["h", "e", "l", "l", "o"].reverse();
      // ["o", "l", "l", "e", "h"]

      // Step 3. Use the join() method to join all elements of the array into a string
      var joinArray = reverseArray.join('') // var joinArray = ["o", "l", "l", "e", "h"].join("");
      // "olleh"

      //Step 4. Return the reversed string
      return joinArray // "olleh"
    },
    SumMabTaahodatRiz(list) {
      let sum = 0
      for (let index = 0; index < list.length; index++) {
        sum += Number(list[index].mablaghGhest) + (Number(list[index].mabJarime) - Number(list[index].mabBakhshesh))
      }
      return sum
    },
  },
  created() {},
  mounted() {
    this.$store.state.ListTaahodatRizInCart = []
    this.$PutCommatoInput()
    this.GetTaahodat(true)
    this.GetTaahodat(false)

    this.GetTaahodatSahebHesab(true)
    this.GetTaahodatSahebHesab(false)
  },
  updated() {
    this.$PutCommatoInput()
  },
}
</script>
<style scoped>
.Transparent {
  background-color: transparent;
  font-size: 16px !important;
}

input {
  border: 2px dashed #eba422;
  direction: ltr;
}
</style>
